import { InjectionToken } from '@angular/core';

export type DynamicTitlePageFn = (item: any) => string;
export const DYNAMIC_TITLE_PAGE_FN = new InjectionToken<DynamicTitlePageFn>('DYNAMIC_TITLE_FN');
